// extracted by mini-css-extract-plugin
module.exports = {"contentPreview":"ContentPreview_contentPreview__3O712","theme-for-table":"ContentPreview_theme-for-table__1nQ3t"};